import { NavLink, Outlet } from 'react-router-dom';

const TABS = [
  { to: '/account', label: 'Profile', end: true },
  { to: '/account/security', label: 'Sign-in & security' },
  { to: '/account/appearance', label: 'Appearance' },
];

/** Account settings, one topic per tab. */
export function AccountLayout() {
  return (
    <div className="max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Account</h1>
        <nav className="mt-4 flex flex-wrap gap-1 border-b border-border">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) =>
                `-mb-px border-b-2 px-3 py-2 text-sm ${isActive ? 'border-primary font-medium text-foreground' : 'border-transparent text-muted-foreground hover:text-foreground'}`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <Outlet />
    </div>
  );
}
